<template>
  <div>
    <el-space wrap>
      <el-input v-model="obj.searchValue" placeholder="名称/代码 搜索主力合约" @input="handleInput" @keyup.enter="handleEnter"
        style="width: 250px;">
        <template #prefix>
          <el-icon class="el-input__icon">
            <search />
          </el-icon>
        </template>
      </el-input>
      <el-select v-model="obj.intervalValue" @change="handleSelectChange" style="width: 150px;">
        <template #prefix>
          <el-icon class="el-input__icon">
            <tickets />
          </el-icon>
        </template>
        <el-option v-for="item in obj.intervalList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <!-- <el-select v-model="obj.rangeValue" @change="handleSelectRangeChange" style="width: 150px;">
        <template #prefix>
          <el-icon class="el-input__icon">
            <calendar />
          </el-icon>
        </template>
        <el-option v-for="item in obj.rangeList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select> -->
      <!-- <el-date-picker v-model="obj.date" type="daterange" range-separator=" ~ " start-placeholder="开始日期"
        end-placeholder="结束日期" :disabled-date="disabledDate" @change="handleDateChange" format="YYYY/MM/DD"
        value-format="YYYY-MM-DD" /> -->
      <el-button type="primary" @click="handleRefresh">刷新</el-button>
      <!-- <el-button type="primary" @click="handleCorrelation">相关</el-button> -->
      <!-- <el-button type="primary" @click="handleHistory">历史</el-button> -->
      <!-- <el-button type="primary" @click="handleTrade">交易</el-button> -->
      <div v-if="obj.industry != '板块指数'"> <!--当指数的k线时，不显示收藏按钮-->
        <el-button type="primary" @click="handleCancelFavorites" v-if="obj.isFavorites == true">
          <el-icon class="el-input__icon">
            <star />
          </el-icon>移除自选
        </el-button>
        <el-button type="primary" @click="handleAddFavorites" v-if="obj.isFavorites == false">
          <el-icon class="el-input__icon">
            <star />
          </el-icon>加入自选
        </el-button>
      </div>
      <el-tag type="warning" size="small">显示对应级别的最近120根K线（15分钟线约等于最近一周，1小时线约等于最近一月）</el-tag>
    </el-space>
    <div style="float:right; width:240px; padding-top:20px;">
      <el-descriptions title="" :column="1" size="small" border>
        <el-descriptions-item label="名称" label-align="right" align="right" width="50px">{{ obj.name
          }}</el-descriptions-item>
        <el-descriptions-item label="代码" label-align="right" align="right">{{ obj.symbol }}</el-descriptions-item>
        <!-- <el-descriptions-item label="卖出" label-align="right" align="right"><el-tag size="small" type="success">{{
        obj.av1
      }}</el-tag></el-descriptions-item>
        <el-descriptions-item label="买入" label-align="right" align="right"><el-tag size="small" type="danger">{{ obj.bv1
            }}</el-tag></el-descriptions-item> -->
        <el-descriptions-item label="最新" label-align="right" align="right">
          <div v-html="obj.closeString"></div>
        </el-descriptions-item>
        <el-descriptions-item label="涨跌" label-align="right" align="right">
          <div v-html="obj.chg"></div>
        </el-descriptions-item>
        <el-descriptions-item label="开盘" label-align="right" align="right">
          <div v-html="obj.open"></div>
        </el-descriptions-item>
        <el-descriptions-item label="最高" label-align="right" align="right">
          <div v-html="obj.high"></div>
        </el-descriptions-item>
        <el-descriptions-item label="最低" label-align="right" align="right">
          <div v-html="obj.low"></div>
        </el-descriptions-item>
        <el-descriptions-item label="成交" label-align="right" align="right">
          <div v-html="obj.vol"></div>
        </el-descriptions-item>
        <el-descriptions-item label="持仓" label-align="right" align="right">
          <div v-html="obj.opi"></div>
        </el-descriptions-item>
        <el-descriptions-item label="结算" label-align="right" align="right">
          <div v-html="obj.sett"></div>
        </el-descriptions-item>
        <el-descriptions-item label="前收" label-align="right" align="right">
          <div v-html="obj.preClose"></div>
        </el-descriptions-item>
        <el-descriptions-item label="前结" label-align="right" align="right">
          <div v-html="obj.preSett"></div>
        </el-descriptions-item>
        <!-- <el-descriptions-item label="涨停" label-align="right" align="right">
          <div v-html="obj.ulp"></div>
        </el-descriptions-item>
        <el-descriptions-item label="跌停" label-align="right" align="right">
          <div v-html="obj.llp"></div>
        </el-descriptions-item> -->
      </el-descriptions>
      <el-descriptions direction="vertical" title=" " :column="2" size="small" border v-if="obj.summary !== ''">
        <el-descriptions-item label="走势分析" label-align="left" align="left">
          <el-text class="pre-wrap-text">{{ obj.summary }}</el-text>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div style="width: 250px; max-height: 420px;" class='search-ul'>
      <div v-for="data in obj.filteredList" :key="data" class="search-li" @click="handleClick(data)">
        {{ data['name'] }} {{ data['symbol'] }} {{ data['exchange'] }}
        <span v-if="data['main'] === 1"> *主力 </span>
      </div>
    </div>
    <div style="width: 1000px;" class='absolute-div absolute-div-left' v-if="obj.isShow">
      <span v-html="obj.closeString" style="padding-right: 10px;"></span>
      <span v-html="obj.chg" style="padding-right: 10px;"></span>
      <span style="color:black">MA5:{{ obj.ma1 }}&nbsp;</span>
      <span style="color:blue">MA10:{{ obj.ma2 }}&nbsp;</span>
      <span style="color:pink">MA20:{{ obj.ma3 }}&nbsp;&nbsp;</span>
      <span style="color:orange">BOLL_MID:{{ obj.boll_mid }}&nbsp;&nbsp;</span>
      <span style="color:black">K:{{ obj.k }}&nbsp;</span>
      <span style="color:black">D:{{ obj.d }}&nbsp;</span>
      <span style="color:black">J:{{ obj.j }}&nbsp;&nbsp;</span>
      <span style="color:black">MACD(12,26,9):{{ obj.macd_2 }}&nbsp;</span>
      <span style="color:black">DIFF:{{ obj.diff_2 }}&nbsp;</span>
      <span style="color:black">DEA:{{ obj.dea_2 }}&nbsp;</span>
    </div>
    <div id="chart" :style="'height:' + (store.state.windowHeight / 2 - 90) + 'px'" ref="chartDomRef"
      @click="handleChartClick"></div>
      <el-tabs v-model="obj.category" @tab-click="handleTabClick" style="padding-top: 10px;">
      <el-tab-pane label="商品指数" name="商品指数"></el-tab-pane>
      <el-tab-pane label="贵金属" name="贵金属"></el-tab-pane>
      <el-tab-pane label="有色板块" name="有色板块"></el-tab-pane>
      <el-tab-pane label="黑链" name="黑链"></el-tab-pane>
      <el-tab-pane label="化工板块" name="化工板块"></el-tab-pane>
      <el-tab-pane label="石油板块" name="石油板块"></el-tab-pane>
      <el-tab-pane label="油脂链" name="油脂链"></el-tab-pane>
      <!-- <el-tab-pane :label=obj.industry :name=obj.industry></el-tab-pane> -->
      <!-- <el-tab-pane v-if="obj.industry != '-'" :label=obj.industry :name=obj.industry></el-tab-pane> -->
    </el-tabs>
    <div style="width: 1000px;" class='absolute-div absolute-div-left' v-if="obj.isShow">
      <span v-html="obj.closeString_2" style="padding-right: 10px;"></span>
      <span v-html="obj.chg_2" style="padding-right: 10px;"></span>
      <span style="color:black">MA5:{{ obj.ma1_2 }}&nbsp;</span>
      <span style="color:blue">MA10:{{ obj.ma2_2 }}&nbsp;</span>
      <span style="color:pink">MA20:{{ obj.ma3_2 }}&nbsp;&nbsp;</span>
      <span style="color:orange">BOLL_MID:{{ obj.boll_mid_2 }}&nbsp;&nbsp;</span>
      <span style="color:black">K:{{ obj.k_2 }}&nbsp;</span>
      <span style="color:black">D:{{ obj.d_2 }}&nbsp;</span>
      <span style="color:black">J:{{ obj.j_2 }}&nbsp;&nbsp;</span>
      <span style="color:black">MACD:{{ obj.macd_2_2 }}&nbsp;</span>
      <span style="color:black">DIFF:{{ obj.diff_2_2 }}&nbsp;</span>
      <span style="color:black">DEA:{{ obj.dea_2_2 }}&nbsp;</span>
    </div>
    <div id="chart2" :style="'height:' + (store.state.windowHeight / 2 - 90) + 'px'" ref="chartDomRef2"
      @click="handleChartClick">
    </div>  
  </div>
</template>

<script>
import { http, httpNoLoading } from '../util/http'
import { bigNumberTransform, formatDecimalPoint, isMarketTime } from '../util/base'
import { onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { setCharts, calcOption, setEvent } from '../module/k'
import { ElMessage } from 'element-plus'
export default {
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const chartDomRef = ref()
    const chartDomRef2 = ref()
    const obj = reactive({
      windowWidth: 0,
      windowHeight: 0,
      searchList: [],
      filteredList: [],
      searchValue: '',
      block: '',
      intervalList: [{ value: 'MIN', label: '15分钟线' }, { value: 'H', label: '1小时线' }, { value: 'D', label: '日线' }, { value: 'W', label: '周线' }, { value: 'M', label: '月线' }],
      // intervalList: [{ value: 'D', label: '日线' }, { value: 'W', label: '周线' }, { value: 'M', label: '月线' }],
      intervalValue: 'D',
      rangeList: [{ value: '1', label: '最近 1个月' }, { value: '2', label: '最近 2个月' }, { value: '3', label: '最近 3个月' }, { value: '6', label: '最近 半年' }, { value: '12', label: '最近 1年' }],
      rangeValue: '12',
      date: '',
      isShow: false,
      ma1: '',
      ma2: '',
      ma3: '',
      boll_mid: '',
      macd: '',
      diff: '',
      dea: '',
      macd_2: '',
      diff_2: '',
      dea_2: '',
      k: '',
      d: '',
      j: '',

      ma1_2: '',
      ma2_2: '',
      ma3_2: '',
      boll_mid_2: '',
      macd_2: '',
      diff_2: '',
      dea_2: '',
      macd_2_2: '',
      diff_2_2: '',
      dea_2_2: '',
      k_2: '',
      d_2: '',
      j_2: '',

      industry: '',
      summary: '',
      name: '',
      symbol: '',
      close: '',
      closeString: '',
      chgPct: '',
      chg: '',
      open: '',
      low: '',
      high: '',
      vol: '',
      opi: '',
      opiChg: '',
      preSett: '',
      preClose: '',
      sett: '',
      ulp: '',
      llp: '',
      ap1: '',
      av1: '',
      bp1: '',
      bv1: '',

      industry_2: '',
      summary_2: '',
      name_2: '',
      symbol_2: '',
      close_2: '',
      closeString_2: '',
      chgPct_2: '',
      chg_2: '',
      open_2: '',
      low_2: '',
      high_2: '',
      vol_2: '',
      // opi: '',
      // opiChg: '',
      // preSett: '',
      preClose_2: '',
      // sett: '',
      ulp_2: '',
      llp_2: '',
      ap1_2: '',
      av1_2: '',
      bp1_2: '',
      bv1_2: '',

      timer: null,
      // myChart: null,

      category: "商品指数",
      symbolList: [],
      isFavorites: false
    })

    let myChart = null // 定义普通变量来接收ECharts实例(用Vue的proxy接收,tooltip显示会有问题)
    var start = 0 // 防止数据更新后dataZoom被重置
    var end = 0 // 防止数据更新后dataZoom被重置

    let myChart2 = null

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      if (route.query.name != null) {
        obj.searchValue = route.query.name
      }
      if (route.query.interval != null) {
        obj.intervalValue = route.query.interval
      }
      renderView()
      document.addEventListener('keydown', handleKeydown) // 绑定ESC按键事件
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      myChart && myChart.getZr().off('mousemove', function () { }) // 注销事件
      myChart && myChart.off('dataZoom', function () { }) // 注销事件
      clearInterval(obj.timer)
      document.removeEventListener('keydown', handleKeydown) // 绑定ESC按键事件
    })

    // 绑定ESC按键事件
    const handleKeydown = (event) => {
      if (event.key === 'Escape') {
        // Handle ESC key event here
        // console.log('ESC key pressed')
        router.back()
      }
    }

    // 渲染画面
    const renderView = () => {
      renderSelect()
      renderIndicator()
      renderChart()
    }

    // 渲染指标初始状态
    const renderIndicator = () => {
      obj.isShow = false
      obj.ma1 = ''
      obj.ma2 = ''
      obj.ma3 = ''
      obj.boll_mid = ''
      obj.macd = ''
      obj.diff = ''
      obj.dea = ''
      obj.macd_2 = ''
      obj.diff_2 = ''
      obj.dea_2 = ''
      obj.k = ''
      obj.d = ''
      obj.j = ''

      obj.ma1_2 = ''
      obj.ma2_2 = ''
      obj.ma3_2 = ''
      obj.boll_mid_2 = ''
      obj.macd_2 = ''
      obj.diff_2 = ''
      obj.dea_2 = ''
      obj.macd_2_2 = ''
      obj.diff_2_2 = ''
      obj.dea_2_2 = ''
      obj.k_2 = ''
      obj.d_2 = ''
      obj.j_2 = ''
    }

    // 获取自选数据
    const renderFavorites = () => {
      // 获取前先清空本地数据
      obj.symbolList = []
      obj.isFavorites = false

      http({
        url: '/favorites',
        method: 'post',
      }).then((res) => {
        // console.log(res.data.data) // 东方财富 300059, 平安银行 000001
        let symbolList = res.data.data.split(',')
        symbolList.forEach((item) => {
          let splitedItem = item.split(' ')
          if (splitedItem.length === 2) {
            obj.symbolList.push({ 'name': splitedItem[0], 'symbol': splitedItem[1] })
            // 判读是否已经添加了自选
            if (splitedItem[0] === obj.name){
              obj.isFavorites = true
            }
          }
        })
        // console.log(obj.symbolList)
        // console.log(obj.isFavorites)
      })
    }

    // 获取数据渲染下拉框
    const renderSelect = () => {
      let formData = new FormData()
      formData.append("category", "main")
      http({
        url: '/contract',
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        obj.searchList = res.data.data
      })
    }

    // 获取数据渲染下拉框
    const renderSummary = () => {
      let formData = new FormData()
      formData.append("name", obj.name)
      // 行业和市场指数的k线，则不做summary请求
      if (obj.exchange == "-") {
        return
      }
      http({
        url: '/summary',
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        obj.summary = res.data.data.text
      })
    }

    // 搜索框输入事件
    const handleInput = () => {
      if (obj.searchValue.trim() === '') {
        obj.filteredList = []
        return
      }
      obj.filteredList = obj.searchList.filter(item => item['name'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()) ||
        item['symbol'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()))
    }

    // 搜索框回车事件
    const handleEnter = () => {
      if (obj.filteredList.length != 0) {
        obj.searchValue = obj.filteredList[0]['name']
      }
      obj.filteredList = []
      renderChart()

    }

    // 搜索结果点击事件
    const handleClick = (data) => {
      obj.searchValue = data['name']
      obj.filteredList = []
      renderChart()
    }

    // interval下拉框选择事件
    const handleSelectChange = () => {
      renderChart()
    }

    // range下拉框选择事件
    const handleSelectRangeChange = () => {
      obj.date = ''
      renderChart()
    }

    // 日期picker不能选择今天之后的日子
    const disabledDate = (time) => {
      return time.getTime() > Date.now()
    }

    // 日期picker选择时间
    const handleDateChange = () => {
      // console.log(obj.date)
      if (obj.date === null) {
        obj.rangeValue = '1'
      } else {
        obj.rangeValue = ''
      }
      renderChart()
    }

    // 图表点击事件
    const handleChartClick = () => {
      obj.filteredList = []
      // obj.searchValue = ''
    }

    // 获取数据渲染图表
    const renderChart = () => {
      requestData(true)
      clearInterval(obj.timer)
      obj.timer = setInterval(function () {
        // 如不在开盘时间，则停止获取数据
        if (!isMarketTime()) {
          clearInterval(obj.timer)
          return
        }
        // 获取最新行情数据
        requestData(false)
      }, 60000) // 每60秒刷新数据
    }

    // 获取数据
    const requestData = (isLoading = true) => {
      let formData = new FormData()
      formData.append("name", obj.searchValue)
      formData.append("interval", obj.intervalValue)
      formData.append("range", obj.rangeValue)
      formData.append("date", obj.date)
      if (isLoading) {
        if (obj.searchValue.trim() !== '') {
          http({
            url: `/candlestick`,
            method: 'post',
            data: formData
          }).then((res) => {
            // console.log(res.data.data)
            processData(res)
            setStore()
            renderIndicator()
            obj.isShow = true
            renderSummary()
            renderFavorites()
          }).catch((err) => {
            clearInterval(obj.timer)
          })
        }
      } else {
        if (obj.searchValue.trim() !== '') {
          httpNoLoading({
            url: `/candlestick`,
            method: 'post',
            data: formData
          }).then((res) => {
            // console.log(res.data.data)
            processData(res)
            setStore()
            renderIndicator()
            obj.isShow = true
            renderSummary()
            renderFavorites()
          }).catch((err) => {
            clearInterval(obj.timer)
          })
        }
      }

      // 获取关联市场指数和行业指数
      formData = new FormData()
      formData.append("name", obj.category)
      formData.append("interval", obj.intervalValue)
      formData.append("range", obj.rangeValue)
      formData.append("date", obj.date)
      if (isLoading) {
        if (obj.searchValue.trim() !== '') {
          http({
            url: `/candlestick`,
            method: 'post',
            data: formData
          }).then((res) => {
            // console.log(res.data.data)
            processData2(res)
            setStore()
            // renderIndicator()
            // obj.isShow = true
            // renderSummary()
          }).catch((err) => {
            // clearInterval(obj.timer)
          })
        }
      } else {
        if (obj.searchValue.trim() !== '') {
          httpNoLoading({
            url: `/candlestick`,
            method: 'post',
            data: formData
          }).then((res) => {
            // console.log(res.data.data)
            processData2(res)
            setStore()
            // renderIndicator()
            // obj.isShow = true
            // renderSummary()
          }).catch((err) => {
            // clearInterval(obj.timer)
          })
        }
      }
    }

    // 加工处理数据
    const processData = (res) => {
      // console.log(res.data.data)
      var rawData = res.data.data[0]
      var rawMa = res.data.data[1]
      var rawMACD = res.data.data[2]
      var rawMACD_2 = res.data.data[3]
      var rawBoll = res.data.data[4]
      var rawKDJ = res.data.data[5]

      var ctpList = res.data.data[6]
      ctpList.forEach((item) => {
        if (item.chgPct !== "-") {
          obj.name = item.name
          obj.symbol = item.symbol
          obj.exchange = item.exchange
          obj.industry = item.industry

          item.chgPct = item.chgPct + '%'
          item.vol = bigNumberTransform(parseFloat(item.vol))
          item.opi = bigNumberTransform(parseFloat(item.opi))
          // 不是指数k线时才做以下处理
          if (obj.exchange != "-") { 
            item.chg = formatDecimalPoint(parseFloat(item.chg), item.symbol)
            item.close = formatDecimalPoint(parseFloat(item.close), item.symbol)
            item.open = formatDecimalPoint(parseFloat(item.open), item.symbol)
            item.low = formatDecimalPoint(parseFloat(item.low), item.symbol)
            item.high = formatDecimalPoint(parseFloat(item.high), item.symbol)
            item.preSett = formatDecimalPoint(parseFloat(item.preSett), item.symbol)
            item.preClose = formatDecimalPoint(parseFloat(item.preClose), item.symbol)
          }
          // if (item.close > item.preSett) {
          //   obj.close = "<span style='color:red;font-weight:bold;'>" + item.close + "</span>"
          //   obj.chg = "<span style='color:red;font-weight:bold;'>" + item.chg + '/' + item.chgPct + "</span>"
          //   obj.open = "<span style='color:red'>" + item.open + "</span>"
          //   obj.low = "<span style='color:red'>" + item.low + "</span>"
          //   obj.high = "<span style='color:red'>" + item.high + "</span>"
          // } else if (item.close < item.preSett) {
          //   obj.close = "<span style='color:green;font-weight:bold;'>" + item.close + "</span>"
          //   obj.chg = "<span style='color:green;font-weight:bold;'>" + item.chg + '/' + item.chgPct + "</span>"
          //   obj.open = "<span style='color:green'>" + item.open + "</span>"
          //   obj.low = "<span style='color:green'>" + item.low + "</span>"
          //   obj.high = "<span style='color:green'>" + item.high + "</span>"
          // }

          if (item.close > item.preSett) {
            obj.closeString = "<span style='color:red;font-weight:bold;'>" + item.close + "</span>"
            obj.chg = "<span style='color:red;font-weight:bold;'>" + item.chg + '/' + item.chgPct + "</span>"
          } else if (item.close < item.preSett) {
            obj.closeString = "<span style='color:green;font-weight:bold;'>" + item.close + "</span>"
            obj.chg = "<span style='color:green;font-weight:bold;'>" + item.chg + '/' + item.chgPct + "</span>"
          } else {
            obj.closeString = "<span style='font-weight:bold;'>" + item.close + "</span>"
            obj.chg = "<span style='font-weight:bold;'>" + item.chg + '/' + item.chgPct + "</span>"
          }
          if (item.open > item.preSett) {
            obj.open = "<span style='color:red'>" + item.open + "</span>"
          } else if (item.open < item.preSett) {
            obj.open = "<span style='color:green'>" + item.open + "</span>"
          } else {
            obj.open = item.open
          }
          if (item.low > item.preSett) {
            obj.low = "<span style='color:red'>" + item.low + "</span>"
          } else if (item.low < item.preSett) {
            obj.low = "<span style='color:green'>" + item.low + "</span>"
          } else {
            obj.low = item.low
          }
          if (item.high > item.preSett) {
            obj.high = "<span style='color:red'>" + item.high + "</span>"
          } else if (item.high < item.preSett) {
            obj.high = "<span style='color:green'>" + item.high + "</span>"
          } else {
            obj.high = item.high
          }

          obj.vol = item.vol
          obj.opi = item.opi
          if (item.opiChg > 0) {
            obj.opiChg = "<span style='color:red'>" + item.opiChg + "</span>"
          } else if (item.opiChg < 0) {
            obj.opiChg = "<span style='color:green'>" + item.opiChg + "</span>"
          }
          obj.preSett = item.preSett
          obj.preClose = item.preClose

          if (parseFloat(item.sett) > 10000000000) {
            obj.sett = '-'
          } else {
            obj.sett = item.sett
          }
          obj.ulp = "<span style='color:red'>" + item.ulp + "</span>"
          obj.llp = "<span style='color:green'>" + item.llp + "</span>"
          obj.ap1 = item.ap1
          obj.av1 = item.av1
          obj.bp1 = item.bp1
          obj.bv1 = item.bv1
        } else {
          obj.name = item.name
          obj.symbol = item.symbol
          obj.close = "-"
          obj.chg = "-"
          obj.open = "-"
          obj.low = "-"
          obj.high = "-"
          obj.vol = "-"
          obj.opi = "-"
          obj.opiChg = "-"
          obj.preSett = "-"
          obj.preClose = "-"
          obj.sett = '-'
          obj.ulp = "-"
          obj.llp = "-"
          obj.ap1 = "-"
          obj.av1 = "-"
          obj.bp1 = "-"
          obj.bv1 = "-"
        }
      })

      if (myChart !== null) {
        var option = calcOption(obj.searchValue, rawData, rawMa, rawMACD, rawMACD_2, rawBoll, rawKDJ)
        // console.log(start)
        // console.log(end)
        if (start != 0 && end != 0) {
          option.dataZoom[0].start = start; // 防止数据更新后dataZoom被重置
          option.dataZoom[0].end = end; // 防止数据更新后dataZoom被重置
        }
        option && myChart.setOption(option, true, false)
        // setEvent(myChart, mouseMoveCallback)
        // myChart = setCharts(chartDomRef.value, obj.searchValue, rawData, rawMa, rawMACD, rawMACD_2, rawBoll, rawKDJ, mouseMoveCallback)
      } else {
        myChart = setCharts(chartDomRef.value, obj.searchValue, rawData, rawMa, rawMACD, rawMACD_2, rawBoll, rawKDJ, mouseMoveCallback)
      }
      myChart.off('dataZoom', function () { })
      myChart.on('dataZoom', function (event) { // 防止数据更新后dataZoom被重置
        if (event.batch) {
          start = event.batch[0].start;
          end = event.batch[0].end;
        } else {
          start = event.start;
          end = event.end;
        };
      });
    }

    // 加工处理数据2
    const processData2 = (res) => {
      // console.log(res.data.data)
      var rawData = res.data.data[0]
      var rawMa = res.data.data[1]
      var rawMACD = res.data.data[2]
      var rawMACD_2 = res.data.data[3]
      var rawBoll = res.data.data[4]
      var rawKDJ = res.data.data[5]

      var ctpList = res.data.data[6]
      console.log(ctpList)
      ctpList.forEach((item) => {
        if (item.chgPct !== "-") {
          obj.exchange_2 = item.exchange
          obj.industry_2 = item.industry

          item.chgPct = item.chgPct + '%'
          item.vol = bigNumberTransform(parseFloat(item.vol / 100))
          // item.opi = bigNumberTransform(parseFloat(item.opi))
          item.chg = parseFloat(item.chg).toFixed(2)
          item.chgPct = (parseFloat(item.chgPct) * 100).toFixed(2)
          obj.close_2 = item.close
          // item.close = formatDecimalPoint(parseFloat(item.close), item.symbol)
          // item.open = formatDecimalPoint(parseFloat(item.open), item.symbol)
          // item.low = formatDecimalPoint(parseFloat(item.low), item.symbol)
          // item.high = formatDecimalPoint(parseFloat(item.high), item.symbol)
          // item.preSett = formatDecimalPoint(parseFloat(item.preSett), item.symbol)
          // item.preClose = formatDecimalPoint(parseFloat(item.preClose), item.symbol)

          obj.industry_2 = item.industry
          obj.index_2 = item.index
          obj.district_2 = item.district

          obj.name_2 = item.name
          obj.symbol_2 = item.symbol
          if (item.close > item.preClose) {
            obj.closeString_2 = "<span style='color:red;font-weight:bold;'>" + item.close + "</span>"
            obj.chg_2 = "<span style='color:red;font-weight:bold;'>" + item.chg + '/' + item.chgPct + '%' + "</span>"
          } else if (item.close < item.preClose) {
            obj.closeString_2 = "<span style='color:green;font-weight:bold;'>" + item.close + "</span>"
            obj.chg_2 = "<span style='color:green;font-weight:bold;'>" + item.chg + '/' + item.chgPct + '%' + "</span>"
          } else {
            obj.closeString_2 = "<span style='font-weight:bold;'>" + item.close + "</span>"
            obj.chg_2 = "<span style='font-weight:bold;'>" + item.chg + '/' + item.chgPct + '%' + "</span>"
          }
          if (item.open > item.preClose) {
            obj.open_2 = "<span style='color:red'>" + item.open + "</span>"
          } else if (item.open < item.preClose) {
            obj.open_2 = "<span style='color:green'>" + item.open + "</span>"
          } else {
            obj.open_2 = item.open
          }
          if (item.low > item.preClose) {
            obj.low_2 = "<span style='color:red'>" + item.low + "</span>"
          } else if (item.low < item.preClose) {
            obj.low_2 = "<span style='color:green'>" + item.low + "</span>"
          } else {
            obj.low_2 = item.low
          }
          if (item.high > item.preClose) {
            obj.high_2 = "<span style='color:red'>" + item.high + "</span>"
          } else if (item.high < item.preClose) {
            obj.high_2 = "<span style='color:green'>" + item.high + "</span>"
          } else {
            obj.high_2 = item.high
          }

          obj.vol_2 = item.vol
          // obj.opi = item.opi
          // if (item.opiChg > 0) {
          //   obj.opiChg = "<span style='color:red'>" + item.opiChg + "</span>"
          // } else if (item.opiChg < 0) {
          //   obj.opiChg = "<span style='color:green'>" + item.opiChg + "</span>"
          // }
          // obj.preSett = item.preSett
          obj.preClose_2 = item.preClose

          // if (parseFloat(item.sett) > 10000000000) {
          //   obj.sett = '-'
          // } else {
          //   obj.sett = item.sett
          // }
          // obj.ulp = "<span style='color:red'>" + item.ulp + "</span>"
          // obj.llp = "<span style='color:green'>" + item.llp + "</span>"
          // obj.ap1 = item.ap1
          // obj.av1 = item.av1
          // obj.bp1 = item.bp1
          // obj.bv1 = item.bv1
        } else {
          // obj.name = item.name
          // obj.symbol = item.symbol
          // obj.close = "-"
          // obj.chg = "-"
          // obj.open = "-"
          // obj.low = "-"
          // obj.high = "-"
          // obj.vol = "-"
          // // obj.opi = "-"
          // // obj.opiChg = "-"
          // // obj.preSett = "-"
          // obj.preClose = "-"
          // // obj.sett = '-'
          // obj.ulp = "-"
          // obj.llp = "-"
          // obj.ap1 = "-"
          // obj.av1 = "-"
          // obj.bp1 = "-"
          // obj.bv1 = "-"
        }
      })

      if (myChart2 !== null) {
        var option = calcOption(obj.category, rawData, rawMa, rawMACD, rawMACD_2, rawBoll, rawKDJ)
        // console.log(start)
        // console.log(end)
        if (start != 0 && end != 0) {
          option.dataZoom[0].start = start; // 防止数据更新后dataZoom被重置
          option.dataZoom[0].end = end; // 防止数据更新后dataZoom被重置
        }
        option && myChart2.setOption(option, true, false)
        // setEvent(myChart, mouseMoveCallback2)
        // myChart = setCharts(chartDomRef.value, obj.searchValue, rawData, rawMa, rawMACD, rawMACD_2, rawBoll, rawKDJ, mouseMoveCallback2)
      } else {
        myChart2 = setCharts(chartDomRef2.value, obj.category, rawData, rawMa, rawMACD, rawMACD_2, rawBoll, rawKDJ, mouseMoveCallback2)
      }
      myChart2.off('dataZoom', function () { })
      myChart2.on('dataZoom', function (event) { // 防止数据更新后dataZoom被重置
        if (event.batch) {
          start = event.batch[0].start;
          end = event.batch[0].end;
        } else {
          start = event.start;
          end = event.end;
        };
      });
    }

    // 保存至store
    const setStore = () => {
      store.commit('setMyChart', myChart)// 缓存数据
      store.commit('setMyChart2', myChart2)// 缓存数据
    }

    // 图表mousemove回调函数
    const mouseMoveCallback = (ma1, ma2, ma3, boll_mid, k, d, j, macd_2, diff_2, dea_2) => {
      obj.ma1 = ma1
      obj.ma2 = ma2
      obj.ma3 = ma3
      obj.boll_mid = boll_mid
      obj.k = k
      obj.d = d
      obj.j = j
      obj.macd_2 = macd_2
      obj.diff_2 = diff_2
      obj.dea_2 = dea_2
    }

    // 图表mousemove回调函数2
    const mouseMoveCallback2 = (ma1, ma2, ma3, boll_mid, k, d, j, macd_2, diff_2, dea_2) => {
      obj.ma1_2 = ma1
      obj.ma2_2 = ma2
      obj.ma3_2 = ma3
      obj.boll_mid_2 = boll_mid
      obj.k_2 = k
      obj.d_2 = d
      obj.j_2 = j
      obj.macd_2_2 = macd_2
      obj.diff_2_2 = diff_2
      obj.dea_2_2 = dea_2
    }

    // 图表刷新
    const handleRefresh = (data) => {
      myChart && myChart.resize() // 图表自适应
      myChart2 && myChart2.resize() // 图表自适应
      renderChart()
    }

    // 跳转相关画面
    const handleCorrelation = (data) => {
      for (var i of obj.searchList) {
        if (i['name'] === obj.searchValue) {
          obj.block = i['block']
          break
        }
      }
      router.push(`/correlation?block=${obj.block}`)
    }

    // 跳转历史画面
    const handleHistory = (data) => {
      router.push(`/history?name=${obj.searchValue}`)
    }

    // 跳转交易画面
    const handleTrade = (data) => {
      router.push(`/trade?name=${obj.searchValue}`)
    }

    // tab点击事件
    const handleTabClick = (tab) => {
      obj.category = tab.props.name
      requestData()
    }

    // 移除自选
    const handleCancelFavorites  = () => {
      obj.symbolList.forEach((item) => {
        if (item.name === obj.name) {
          obj.symbolList.splice(obj.symbolList.indexOf(item), 1)
        }
      })
      handleFavorites()
    }

    // 添加自选
    const handleAddFavorites  = () => {
      obj.symbolList.push({ 'name': obj.name, 'symbol': obj.symbol })
      handleFavorites()
    }

    // 保存自选列表
    const handleFavorites = () => {
      let formData = new FormData()
      var symbolList = []
      obj.symbolList.forEach((item) => {
        symbolList.push(item.name + " " + item.symbol)
      })
      // console.log(symbolList.join(","))
      formData.append("favorites", symbolList.join(","))
      httpNoLoading({
        url: `/favorites_update`,
        method: 'post',
        data: formData
      }).then((res) => {
        ElMessage.success("操作成功")
        // obj.dialogFormVisible = false
        // vueEvent.emit('favoritesDialogClose', '')
        renderChart()
      })
    }

    return {
      obj,
      store,
      chartDomRef,
      chartDomRef2,
      disabledDate,
      handleDateChange,
      handleInput,
      handleEnter,
      handleClick,
      handleSelectChange,
      handleSelectRangeChange,
      handleChartClick,
      handleRefresh,
      handleCorrelation,
      handleHistory,
      handleTrade,
      handleTabClick,
      handleCancelFavorites,
      handleAddFavorites
    }
  }

}
</script>
<style lang="scss" scoped>
/* ================================
Components
Search
================================= */
.search-ul {
  position: absolute;
  left: 80px;
  top: 95px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}

.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}

.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
</style>
